import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { QuestionsService } from '../survey/questions.service';

@Injectable({
  providedIn: 'root'
})
export class FormWidgetUtilsService {
  constructor(private questionsService: QuestionsService) {
  }

  updateControlValue(formControl: AbstractControl | null, value: any) {
    formControl?.setValue(value && value !== 'NULL' ? value : null);
    formControl?.updateValueAndValidity();
  }
}
